import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
function About() {
  const [isLoaded, setIsLoaded] = useState(false);
  return (
    <div className="position-relative mt-5">
      <div class="rent-area pb-120">
        <div class="container-fluid">
          <div class="row justify-content-center" data-cues="slideInUp">
            <div class="col-lg-6 col-md-12">
              <div class="rent-content">
                <span class="sub">Exploring the World of Real Estate</span>
                <h2>
                  <b>Gateway LANDMARK GROUP: Shaping the Future Since 2010</b>
                </h2>
                <p>
                  {" "}
                  Gateway Landmark Grouphas been a trailblazer in delivering
                  world-class luxury properties in Jaipur for over 15 years,
                  redefining standards in the real estate industry. Recognized
                  as one of the leading real estate companies in the city, we
                  specialize in premium residential and commercial properties,
                  offering unparalleled amenities in prime locations. <br />
                  With a diverse portfolio of investment opportunities across
                  residential and commercial developments, we consistently
                  exceed client expectations. Supported by a passionate team of
                  over 50 seasoned professionals and experts, Gateway Landmark
                  Grouphas built a legacy of trust, reliability, and excellence
                  in the real estate sector.
                </p>
              </div>
            </div>
            <div class="col-lg-6 col-md-12">
              <div class="rent-image"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default About;
